module.exports = __webpack_public_path__ + "static/media/KH.39e16dba.jpg";